import { MODEL_NAMES } from '../constants/index';
import { service } from '@ember/service';
import MessagingBase from './messaging-base';

export default class MessagingContact extends MessagingBase {
  @service store;

  async fetchContact(externalId) {
    const [contact] = await this.fetchContacts([externalId]);
    return contact;
  }

  async fetchContacts(externalIds = []) {
    const existingContacts = new Map();
    const missingIds = [];

    for (const externalId of externalIds) {
      const cached = this.#checkForExistingRecord(MODEL_NAMES.CONTACT, 'externalId', externalId);
      if (cached) {
        existingContacts.set(externalId, cached);
      } else {
        missingIds.push(externalId);
      }
    }

    const fetchedContacts = new Map();
    if (missingIds.length) {
      const fetched = await this.store.query(MODEL_NAMES.CONTACT, {
        filter: { external_ids: missingIds },
        include: 'couple',
        page: { number: 1, size: missingIds.length },
      });

      for (const contact of fetched) {
        fetchedContacts.set(contact.externalId, contact);
      }
    }

    return externalIds.map(
      externalId => existingContacts.get(externalId) ?? fetchedContacts.get(externalId) ?? null
    );
  }

  #checkForExistingRecord(modelName, key, value) {
    return this.store.peekAll(modelName).find(record => record[key] === value);
  }
}
